import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders a Material-UI TextField for the "name" input field.
 */
export const TextFieldName = ({ values, handleChange, errors, touched }) => {
    return (
        <TextField
            fullWidth
            label={t('users.fields.name')}
            name="name"
            value={values.name}
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
            onChange={handleChange}
        />
    );
};

TextFieldName.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
